import ReactGA from "react-ga4";

import type { Platform } from "~/types/platform";

export enum PlatformClickPlacement {
  Dashboard = "dashboard",
  EventDetail = "event_detail",
  Trending = "trending",
  Breaking = "breaking",
  Calculator = "calculator",
  Other = "other",
}

export const PLATFORM_CLICK_EVENT = "platform_click";

const BEACON_TRANSPORT = "beacon";

export interface IPlatformClick {
  platform: Platform;
  placement: PlatformClickPlacement;
  eventSlug: string | null;
}

interface IPlatformClickParams {
  platform: Platform;
  placement: PlatformClickPlacement;
  event_slug?: string;
  transport_type: typeof BEACON_TRANSPORT;
}

const toEventParams = ({
  platform,
  placement,
  eventSlug,
}: IPlatformClick): IPlatformClickParams => ({
  platform,
  placement,
  ...(eventSlug ? { event_slug: eventSlug } : {}),
  transport_type: BEACON_TRANSPORT,
});

export const trackPlatformClick = (click: IPlatformClick): void => {
  if (!ReactGA.isInitialized) {
    return;
  }

  ReactGA.event(PLATFORM_CLICK_EVENT, toEventParams(click));
};
